export const environment = {
  production: true,
  baseUrl: "https://addaw.canaldenuncia.app/backend",
  baseAvatar: "https://addaw.canaldenuncia.app/assets/avatar/",
  base: "https://addaw.canaldenuncia.app"
  // baseUrl: "https://desarrollo.becompliance.tech/backend",
  // baseAvatar: "https://desarrollo.becompliance.tech/assets/avatar/",
  // base: "https://desarrollo.becompliance.tech"
};
